document.addEventListener("DOMContentLoaded", function () {
  const ticker = document.querySelector(".logo-ticker");
  const tickerWrapper = document.querySelector(".logo-ticker-wrapper");

  // Duplicates only if width >768px
  const items = Array.from(ticker.children);
  if (window.innerWidth > 768) {
    items.forEach(item => {
      const clone = item.cloneNode(true);
      ticker.appendChild(clone);
    });
  }

  let currentPosition = 0;
  const speed = window.innerWidth <= 768 ? 1.2 : 0.5; 
  let ticking = false;
  let animationFrameId;

  function moveTicker() {

    if (!ticking) return;
    
    currentPosition -= speed;
    ticker.style.transform = `translateX(${currentPosition}px)`;

    const firstItem = ticker.children[0];
    const firstItemRect = firstItem.getBoundingClientRect();
    const wrapperRect = tickerWrapper.getBoundingClientRect();

    // When the first item comes completely out from the left
    if (firstItemRect.right < wrapperRect.left) {
      // We move it to the end
      ticker.appendChild(firstItem);
      
      const computedStyle = getComputedStyle(ticker);
      const gap = parseInt(computedStyle.gap) || 0;
      const firstItemWidth = firstItem.offsetWidth + gap;

      currentPosition += firstItemWidth;
      ticker.style.transform = `translateX(${currentPosition}px)`;
    }

    animationFrameId = requestAnimationFrame(moveTicker);
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        ticking = true;
        moveTicker();
      } else {
        ticking = false;
        cancelAnimationFrame(animationFrameId);
      }
    });
  }, { threshold: 0.1 });

  observer.observe(tickerWrapper);
});
  